import type { ServiceOrderSummary } from '#domain/Order.ts';
import { isCanonicalServiceType, parseServiceOrderStopName } from '#domain/serviceOrderStopName.ts';

import type { OrderDialogState } from './OrderDialog.tsx';
import type { ServiceOrderFormData } from './ServiceOrderFormValidation.ts';
import { splitDateTimeValue } from './timeWindowFields.ts';

const getServiceType = (order?: ServiceOrderSummary): ServiceOrderFormData['serviceType'] => {
    if (!order) {
        return 'cleaning';
    }
    const { serviceType } = parseServiceOrderStopName(order.executionStop.name);
    return isCanonicalServiceType(serviceType) ? serviceType : 'other';
};

export const getServiceOrderFormDefaultValues = (
    state: OrderDialogState,
    order?: ServiceOrderSummary
): ServiceOrderFormData => {
    const duplicate = state === 'duplicateOrder';
    const startTarget = duplicate ? { date: '', time: '' } : splitDateTimeValue(order?.executionStop.startTarget);
    const endTarget = duplicate ? { date: '', time: '' } : splitDateTimeValue(order?.executionStop.endTarget);
    const serviceType = getServiceType(order);
    const parsedStopName = parseServiceOrderStopName(order?.executionStop.name ?? serviceType);

    return {
        serviceType,
        otherType: serviceType === 'other' ? parsedStopName.serviceType : '',
        company: parsedStopName.company,
        description: order?.description ?? '',
        note: order?.note ?? '',
        executionStop: {
            name: order?.executionStop.name ?? serviceType,
            location: {
                street: order?.executionStop.location.street ?? '',
                city: order?.executionStop.location.city ?? '',
                zipCode: order?.executionStop.location.zipCode ?? '',
                country: order?.executionStop.location.country ?? '',
            },
            startDate: startTarget.date,
            startTime: startTarget.time,
            endDate: endTarget.date,
            endTime: endTarget.time,
            latitude: order?.executionStop.latitude ? Number(order.executionStop.latitude) : undefined,
            longitude: order?.executionStop.longitude ? Number(order.executionStop.longitude) : undefined,
        },
    };
};
